import {
    Grid,
    Paper,
    Tooltip,
    IconButton,
    styled,
} from "@mui/material";
import { GridColumnsPanel } from "@mui/x-data-grid-premium";
import { useState } from "react";
import SaveIcon from "@mui/icons-material/Save";
import UndoIcon from "@mui/icons-material/Undo";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";

import { useTableViewManager } from "src/hooks/table/tableSettings/useTableViews";
import { TableViewDropdown, ViewNameDialog } from "./TableViewDropdown";




export const CustomColumnsPanel = ({ tableSettings }) => {
    const {
        activeViewId,
        activeViewName,
        viewsList,
        handleViewChange,
        isDirty,
        save,
        discard,
        addView,
        renameView,
        deleteView,
    } = useTableViewManager(tableSettings, { syncGrid: true });

    const [addOpen, setAddOpen] = useState(false);
    const [renameOpen, setRenameOpen] = useState(false);

    return (
        <div style={{ height: 800, minWidth: 400 }}>
            <Paper>
                <Grid container alignItems="center">
                    <Grid item xs={7}>
                        <TableViewDropdown
                            activeViewId={activeViewId}
                            viewsList={viewsList}
                            handleViewChange={handleViewChange}
                        />
                    </Grid>

                    <Grid item xs={1}>
                        <Tooltip title="Add new view">
                            <IconButton size="small" onClick={() => setAddOpen(true)}>
                                <AddIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                    </Grid>

                    <Grid item xs={1}>
                        <Tooltip title="Rename view">
                            <span>
                                <IconButton
                                    size="small"
                                    disabled={activeViewId === "0"}
                                    onClick={() => setRenameOpen(true)}
                                >
                                    <EditIcon fontSize="small" />
                                </IconButton>
                            </span>
                        </Tooltip>
                    </Grid>

                    <Grid item xs={1}>
                        <Tooltip title="Delete view">
                            <span>
                                <IconButton
                                    size="small"
                                    disabled={activeViewId === "0"}
                                    onClick={() => {
                                        if (
                                            window.confirm(
                                                `Delete view “${activeViewName}”?`
                                            )
                                        ) {
                                            deleteView(activeViewId);
                                        }
                                    }}
                                >
                                    <DeleteIcon fontSize="small" />
                                </IconButton>
                            </span>
                        </Tooltip>
                    </Grid>

                    <Grid item xs={1}>
                        <Tooltip title="Save edits">
                            <span>
                                <IconButton
                                    size="small"
                                    disabled={!isDirty}
                                    onClick={save}
                                >
                                    <SaveIcon fontSize="small" />
                                </IconButton>
                            </span>
                        </Tooltip>
                    </Grid>

                    <Grid item xs={1}>
                        <Tooltip title="Discard edits">
                            <span>
                                <IconButton
                                    size="small"
                                    disabled={!isDirty}
                                    onClick={discard}
                                >
                                    <UndoIcon fontSize="small" />
                                </IconButton>
                            </span>
                        </Tooltip>
                    </Grid>
                </Grid>

                <StyledGridColumnsPanel />

                <ViewNameDialog
                    open={addOpen}
                    onClose={() => setAddOpen(false)}
                    onSubmit={addView}
                    title="Create New View"
                    submitLabel="Create"
                    initialValue="New View"
                />

                <ViewNameDialog
                    open={renameOpen}
                    onClose={() => setRenameOpen(false)}
                    onSubmit={name => renameView(activeViewId, name)}
                    title="Rename View"
                    initialValue={activeViewName}
                    submitLabel="Rename"
                />
            </Paper>
        </div>
    );
};

const StyledGridColumnsPanel = styled(GridColumnsPanel)(() => ({
    ".MuiDataGrid-panelHeader": { display: "none !important" },
}));
